import * as ReactDOM from 'react-dom';

interface ILoadingPanel {
  id?: string;
  loadingText?: string;
}

const DarkBackgroundLoadingPanel = ({ id = '', loadingText = '' }: ILoadingPanel) => {
  const loadingPanel = (
    <div className="k-loading-mask flex flex-col items-center justify-center bg-gray-800 bg-opacity-50 pointer-events-none">
      <div className="k-loading-image" />
      <div className="mt-24 text-white">{loadingText}</div>
    </div>
  );

  const gridContent = document && document.querySelector(`${id} .k-grid-content`);
  return gridContent ? ReactDOM.createPortal(loadingPanel, gridContent) : loadingPanel;
};

export default DarkBackgroundLoadingPanel;
